import { type FC } from 'react'
import classNames from 'classnames'
import { Icon, Typography } from 'shared/ui'
import { getLabelAsNumberInternationalFormat } from 'shared/lib'
import styles from './styles.module.scss'

type IForwardToExternalNumber = {
  number: string
}

export const ForwardToExternalNumber: FC<IForwardToExternalNumber> = ({ number }) => {
  const label = getLabelAsNumberInternationalFormat(number)
  return (
    <div className={classNames(styles.content)}>
      <div className={classNames(styles.wrapIcon)}>
        <Icon icon={'arrowRightBold'} fontSize={16} />
      </div>
      <Typography
        tag={'div'}
        variant={'body-sm-regular'}
        color={'var(--content-primary-primary)'}
        ariaLabel={'forward_to_external_number'}
        tooltipProps={{
          label: label,
        }}
        ellipsis
      >
        Forwarded to “{label}”
      </Typography>
    </div>
  )
}
